import {ReviewsData} from "./ReviewsData";

export const ReviewContent = (review: ReviewsData) => {
    return (
        <div className="review__slide">
            <img src={review.avatar} alt={review.name} className="review__avatar"/>
            <h3 className="review__name">{review.name}</h3>
            <p className="review__text">{review.review}</p>
        </div>
    )
}